(function() {
  var utils = window.MidYearSaleUtils || {};
  var qs = utils.qs || function(root, selector) {
    return (root || document).querySelector(selector);
  };
  var qsa = utils.qsa || function(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  };

  function initCountdown(root) {
    var wrap = qs(root, '[data-mys-countdown]');
    if (!wrap) return;
    var target = new Date(wrap.dataset.end || '').getTime();
    if (!target) return;

    function setValue(name, value) {
      var el = qs(wrap, '[data-unit="' + name + '"] .mys-countdown__num');
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    function tick() {
      var left = Math.max(0, target - Date.now());
      var totalSeconds = Math.floor(left / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;
      setValue('days', days);
      setValue('hours', hours);
      setValue('minutes', mins);
      setValue('seconds', secs);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initNav(root) {
    var links = qsa(root, '[data-mys-nav]');
    var nav = qs(root, '.mys-nav');
    if (!links.length) return;
    var navScroll = qs(root, '.mys-nav__scroll');
    var navStart = nav ? nav.getBoundingClientRect().top + window.pageYOffset : 0;
    var currentActive = null;
    var pendingActive = null;
    var pendingTarget = null;
    var pendingTimer = null;

    function scrollNavItemIntoView(button, force) {
      if (!navScroll || !button) return;
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        var containerRect = navScroll.getBoundingClientRect();
        var buttonRect = button.getBoundingClientRect();
        var gutter = 16;
        var targetLeft = navScroll.scrollLeft;
        if (buttonRect.left < containerRect.left + gutter) {
          targetLeft += buttonRect.left - containerRect.left - gutter;
        } else if (buttonRect.right > containerRect.right - gutter) {
          targetLeft += buttonRect.right - containerRect.right + gutter;
        } else if (!force) {
          return;
        }
        if (Math.abs(targetLeft - navScroll.scrollLeft) < 1) return;
        navScroll.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth'
        });
        return;
      }
      var buttonCenter = button.offsetLeft + (button.offsetWidth / 2);
      var scrollLeft = buttonCenter - (navScroll.clientWidth / 2);
      navScroll.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: 'smooth'
      });
    }

    function getNavOffset() {
      return nav ? nav.offsetHeight : 52;
    }

    function setActive(button, forceScroll) {
      links.forEach(function(link) {
        link.classList.toggle('is-active', link === button);
      });
      if (button !== currentActive) {
        currentActive = button;
        scrollNavItemIntoView(button, forceScroll);
      }
    }

    links.forEach(function(button) {
      button.addEventListener('click', function() {
        var target = document.getElementById(button.dataset.target);
        if (!target) return;
        pendingActive = button;
        pendingTarget = target;
        if (pendingTimer) window.clearTimeout(pendingTimer);
        pendingTimer = window.setTimeout(function() {
          pendingActive = null;
          pendingTarget = null;
        }, 1200);
        setActive(button, true);
        window.scrollTo({
          top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - getNavOffset()),
          behavior: 'smooth'
        });
      });
    });

    function update() {
      var active = null;
      var navHeight = nav ? nav.offsetHeight : 52;
      var isFixed = nav && window.pageYOffset >= navStart;
      if (nav) {
        nav.classList.toggle('is-fixed', isFixed);
        var hero = nav.closest ? nav.closest('.mys-hero') : null;
        if (hero) {
          hero.style.setProperty('--mys-nav-height', isFixed ? (nav.offsetHeight + 'px') : '0px');
        }
      }
      document.body.classList.toggle('mys-nav-is-fixed', !!isFixed);
      links.forEach(function(button) {
        var target = document.getElementById(button.dataset.target);
        if (target && target.getBoundingClientRect().top <= navHeight + 28) active = button;
      });
      active = active || links[0];
      if (pendingActive) {
        if (pendingTarget && Math.abs(pendingTarget.getBoundingClientRect().top - getNavOffset()) <= 24) {
          pendingActive = null;
          pendingTarget = null;
          if (pendingTimer) window.clearTimeout(pendingTimer);
        } else {
          setActive(pendingActive);
          return;
        }
      }
      setActive(active);
    }

    function updateNavStart() {
      if (!nav) return;
      nav.classList.remove('is-fixed');
      document.body.classList.remove('mys-nav-is-fixed');
      navStart = nav.getBoundingClientRect().top + window.pageYOffset;
      update();
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', updateNavStart);
  }

  function boot(root) {
    qsa(root, '[data-mid-year-sale]').forEach(function(section) {
      if (section.dataset.boundHero === 'true') return;
      section.dataset.boundHero = 'true';
      initCountdown(section);
      initNav(section);
    });
  }

  function init() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) boot(section);
  });
})();
